import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
} from "@mui/material";

const MessageInteractionNotes = ({ open, handleClose, msgNotes }) => {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: { borderRadius: 2 },
      }}
    >
      <DialogTitle sx={{ color: "black", py: 1 }}>
        <Typography variant="h6" component="div" fontWeight="bold">
          All Interaction Notes
        </Typography>
      </DialogTitle>

      <DialogContent dividers sx={{ p: 0 }}>
        <TableContainer
          component={Paper}
          elevation={0}
          sx={{
            maxHeight: 340,
            overflowY: "auto",
            "&::-webkit-scrollbar": {
              width: 6,
            },
            "&::-webkit-scrollbar-track": {
              background: "transparent",
            },
            "&::-webkit-scrollbar-thumb": {
              background: "#bbb",
              borderRadius: 3,
            },
            "&::-webkit-scrollbar-thumb:hover": {
              background: "#999",
            },
          }}
        >
          <Table stickyHeader aria-label="interaction notes table">
            <TableHead>
              <TableRow>
                <TableCell sx={styles.headerCell}>S.NO</TableCell>
                <TableCell sx={styles.headerCell}>Note Title</TableCell>
                <TableCell sx={styles.headerCell}>Note Detail</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {msgNotes && msgNotes.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={3} align="center" sx={{ py: 6 }}>
                    <Typography variant="body1" color="text.secondary">
                      No Interaction Notes.
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : (
                msgNotes?.map((data, index) => (
                  <TableRow
                    key={data.id || index}
                    hover
                    sx={{
                      "&:nth-of-type(odd)": {
                        backgroundColor: "#f9f9f9",
                      },
                    }}
                  >
                    <TableCell sx={styles.bodyCell}>{index + 1}</TableCell>
                    <TableCell sx={styles.bodyCell}>
                      <Typography variant="body2" fontWeight="medium">
                        {data.Title || "-"}
                      </Typography>
                    </TableCell>
                    <TableCell sx={styles.bodyCell}>
                      <Typography variant="body2">
                        {data.interactionDetail || "-"}
                      </Typography>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>

      <DialogActions sx={{ p: 1 }}>
        <Button
          onClick={handleClose}
          variant="contained"
          color="secondary"
          size="small"
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const styles = {
  headerCell: {
    backgroundColor: "#a5a5a5ff",
    color: "white",
    fontWeight: "bold",
    textAlign: "center",
    py: 1.5,
    fontSize: "0.95rem",
  },
  bodyCell: {
    textAlign: "center",
    py: 1.8,
    fontSize: "0.9rem",
    borderBottom: "1px solid #eee",
  },
};

export default MessageInteractionNotes;
